import React from "react";
import {
  func,
  shape,
  arrayOf,
  string,
  number,
  oneOfType,
  bool,
} from "prop-types";
import * as style from "./styles.module.scss";

const OptionsButton = ({ items, handleChange }) => {
  const calcClassname = (isActive) =>
    isActive ? style.optionsbutton__picked : "";
  return (
    <div
      className={`w-100 btn-group clearfix d-block d-flex ${style.optionsbutton__wrapper}`}
    >
      {items.map((elem, i) => (
        <span
          key={i}
          className={`${style.optionsbutton__pickable} ${calcClassname(
            elem.isActive
          )}`}
          style={i === 0 ? { border: "none" } : {}}
          onClick={() => handleChange(elem.key, elem.value)}
        >
          {elem.text}
        </span>
      ))}
    </div>
  );
};

OptionsButton.propTypes = {
  items: arrayOf(
    shape({
      text: string,
      key: string,
      value: oneOfType([string, number, bool]),
      isActive: bool,
    })
  ).isRequired,
  handleChange: func.isRequired,
};

export default OptionsButton;
